import React, { Component } from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
import moment from "dayjs";

const DATE_FORMAT = "YYYY-MM-DD";

class DateRangePicker extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    allowClear: PropTypes.bool
  };

  static defaultProps = {
    disabled: false,
    allowClear: false
  };

  render() {
    const { value, disabled, allowClear } = this.props;
    return (
      <RangePicker
        value={value ? value.split("--").map(ds => moment(ds)) : null}
        format={DATE_FORMAT}
        ranges={{
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "day"), moment().subtract(1, "day")],
          "This Week": [moment().startOf("week"), moment().endOf("week")],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Week": [
            moment()
              .subtract(1, "week")
              .startOf("week"),
            moment()
              .subtract(1, "week")
              .endOf("week")
          ],
          "Last Month": [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month")
          ]
        }}
        onChange={this.onChange}
        disabled={disabled}
        allowClear={allowClear}
      />
    );
  }

  onChange = (dates, dateStrings) => {
    this.props.onChange(dates && dates.length > 0 ? dateStrings.join("--") : undefined);
  };
}

export default DateRangePicker;
